<template>
  <div class="account-profile">
    <h1 class="h3 mb-4">My Profile</h1>
    <b-card
      class="mb-4">
      <b-form>
        <b-form-group
          id="form-group-first-name"
          label="First name"
          label-align="left"
          label-for="form-input-first-name"
          label-cols-sm="3">
          <b-form-input
            id="form-input-first-name"
            v-model="profile.firstName"
            type="text"
            required
            placeholder="First name"
            disabled/>
        </b-form-group>

        <b-form-group
          id="form-group-last-name"
          label="Last name"
          label-align="left"
          label-for="form-input-last-name"
          label-cols-sm="3">
          <b-form-input
            id="form-input-last-name"
            v-model="profile.lastName"
            type="text"
            required
            placeholder="Last name"
            disabled/>
        </b-form-group>

        <b-form-group
          id="form-group-display-name"
          label="Display name"
          label-align="left"
          label-for="form-input-display-name"
          label-cols-sm="3"
          description="This is name is visible to buyers and sellers you interact with.">
          <b-form-input
            id="form-input-display-name"
            v-model="profile.displayName"
            type="text"
            required
            placeholder="Display name"/>
        </b-form-group>

        <!-- eslint-disable max-len -->
        <b-form-group
          id="form-group-phone"
          label="Phone"
          label-align="left"
          label-for="form-input-phone"
          label-cols-sm="3"
          description="This number is used for verification and support. We'll never share your phone with anyone else.">
          <b-form-input
            id="form-input-phone"
            v-model="profile.phone"
            type="text"
            required
            placeholder="111-111-1111"/>
        </b-form-group>
        <!-- eslint-enable max-len -->

        <!-- eslint-disable max-len -->
        <b-form-group
          id="form-group-email"
          label="Email address"
          label-align="left"
          label-for="form-input-email"
          label-cols-sm="3"
          description="Your email is used to sign in. We'll never share your email with anyone else.">
          <b-form-input
            id="form-input-email"
            v-model="profile.email"
            type="email"
            required
            placeholder="Email address"
            disabled/>
        </b-form-group>
        <!-- eslint-enable max-len -->
      </b-form>
      <template
        v-slot:footer>
        <div class="text-right">
          <b-button
            variant="primary"
            squared
            @click="saveProfile">
            Save Profile
          </b-button>
        </div>
      </template>
    </b-card>
    <h2 class="h4 mb-4">Change Password</h2>
    <b-card>
      <b-form>
        <b-form-group
          id="form-group-current-password"
          label="Current password"
          label-align="left"
          label-for="form-input-current-password"
          label-cols-sm="3">
          <b-form-input
            id="form-input-current-password"
            v-model="passwordForm.currentPassword"
            type="password"
            required
            placeholder="Enter your current password"/>
        </b-form-group>
        <b-form-group
          id="form-group-new-password"
          label="New password"
          label-align="left"
          label-for="form-input-new-password"
          label-cols-sm="3">
          <b-form-input
            id="form-input-new-password"
            v-model="passwordForm.newPassword"
            type="password"
            required
            placeholder="Enter a new password"/>
        </b-form-group>
        <b-form-group
          id="form-group-new-password-repeat"
          label="New password again"
          label-align="left"
          label-for="form-input-new-password-repeat"
          label-cols-sm="3">
          <b-form-input
            id="form-input-new-password-repeat"
            v-model="passwordForm.newPasswordRepeat"
            type="password"
            required
            placeholder="Enter new password again"/>
        </b-form-group>
      </b-form>
      <template
        v-slot:footer>
        <div class="text-right">
          <b-button
            variant="primary"
            squared
            @click="savePassword">
            Update Password
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'AccountProfile',
  data() {
    return {
      isProfileLoading: false,
      profile: {
        firstName: '',
        lastName: '',
        displayName: '',
        phone: '',
        email: '',
      },
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        newPasswordRepeat: '',
      },
    }
  },
  methods: {
    async saveProfile() {
      try {
        await this.$http.put('/profile', {
          displayName: this.profile.displayName,
          phone: this.profile.phone,
        })
        this.$bvToast.toast('Your profile has been successfully updated', {
          title: 'Success',
          toaster: 'b-toaster-top-center',
          variant: 'success',
        })
      } catch (err) {
        // TODO
      }
    },
    async savePassword() {
      try {
        await this.$http.put('/authentication/password', {
          oldPassword: this.passwordForm.currentPassword,
          newPassword: this.passwordForm.newPasswordRepeat,
        })
        this.$bvToast.toast('Your password was successfully updated.', {
          title: 'Success',
          toaster: 'b-toaster-top-center',
          variant: 'success',
        })
      } catch (err) {
        this.$bvToast.toast(err.message, {
          title: 'Error',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
        })
      }
    },
  },
  async created() {
    this.isProfileLoading = true
    try {
      const response = await this.$http.get('/profile')
      const { profile } = response.data
      this.profile = profile
    } catch (err) {
      console.log(err)
    }
    this.isProfileLoading = false
  },
}
</script>
